<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: dialogWidth, maxWidth: '95vw' }"
    header="New version available"
    styleClass="version-update-dialog"
>
    <div class="version-update-dialog__content">
        <p class="version-update-dialog__lead">
            A new version of Torna is ready to install.
            @if (latestVersion) {
                <strong>Version {{ latestVersion }}</strong>
            }
        </p>
        <p class="version-update-dialog__hint">
            You can keep working for now. Reload only when you are ready — your current screen is not changed until you choose Reload.
        </p>

        @if (releaseNotes) {
            <section class="version-update-dialog__notes">
                <h4 class="version-update-dialog__notes-title">{{ notesTitle }}</h4>
                @if (releaseNotes.items?.length) {
                    <ul class="version-update-dialog__notes-list">
                        @for (item of releaseNotes.items; track item) {
                            <li>{{ item }}</li>
                        }
                    </ul>
                }
            </section>
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="version-update-dialog__footer">
            <p-button
                label="Cancel"
                [outlined]="true"
                severity="secondary"
                (onClick)="cancel()"
            />
            <p-button
                label="Reload"
                icon="pi pi-refresh"
                severity="primary"
                (onClick)="reload()"
            />
        </div>
    </ng-template>
</p-dialog>
